/**
 * Budget API path construction (ZPL-224). All budget endpoints are
 * property-nested and OWNER-ONLY — a non-owner gets 404 everywhere.
 */

/** Create/list collection. */
export function budgetBasePath(propertyId: string): string {
	return `/api/common/properties/${propertyId}/budget-entries`
}

/** A single entry by id. */
export function budgetEntryPath(propertyId: string, entryId: string): string {
	return `${budgetBasePath(propertyId)}/${entryId}`
}
